import "./Main.css";
import Carousel from "../../components/Carousel";
import News from "../../components/News";
const Main = () => {
  return (
    <section className="main">
      <Carousel />
      <News />
    </section>
  );
};

export default Main;
